import apis from './apis';

/**
 * Branded Templates (Wave 5) - branding-template ↔ finalized-draft lineage.
 *
 * A finalized draft is "behind" once the branding template it was finalized with
 * is edited. Branding is deterministic (no AI), so bringing a draft up to date is
 * a safe restyle - these helpers let the branding editor show "N documents use an
 * older version of this branding" and re-apply the current branding to them.
 */

export interface BrandingAffectedDraft {
  uuid: string;
  name: string | null;
  matter_uuid: string | null;
  branding_template_version: number | null;
}

export interface BrandingAffected {
  count: number;
  latest_version: number;
  drafts: BrandingAffectedDraft[];
}

/** Passive check - finalized drafts behind this branding template's latest version. */
export async function getBrandingAffected(templateId: string): Promise<BrandingAffected> {
  const res = await apis.get(`/templates/branding/${templateId}/affected`);
  return res.data as BrandingAffected;
}

export interface BrandingReapplyResult {
  applied: number;
  failed: number;
  total: number;
  version: number;
}

/**
 * Re-apply the current branding to the affected finalized drafts. Pass
 * `draftUuids` to scope to a subset; omit to re-apply to all affected drafts.
 */
export async function reapplyBranding(
  templateId: string,
  draftUuids?: string[],
): Promise<BrandingReapplyResult> {
  const body = draftUuids && draftUuids.length ? { draft_uuids: draftUuids } : {};
  const res = await apis.post(`/templates/branding/${templateId}/reapply`, body);
  return res.data as BrandingReapplyResult;
}
